import React from "react";

import ShiftStream from "../..";
import { useAccounts } from "../../graphql/use-accounts";
import Table from "./Table";

export const COL_WIDTHS = [
  "6vw",
  "20vw",
  "10vw",
  "12vw",
  "12vw",
  "12vw",
  "12vw",
  "8vw",
];

export const Home = () => {
  const { accounts, loading } = useAccounts();

  return (
    <ShiftStream>
      <Table accounts={accounts} loading={loading} />
    </ShiftStream>
  );
};

export default Home;
